import { render, staticRenderFns } from "./ContactAdminButton.vue?vue&type=template&id=1942fcaa"
import script from "./ContactAdminButton.vue?vue&type=script&lang=js"
export * from "./ContactAdminButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports